import List from './List';
import Show from './Show';
import { gql } from '@apollo/client';
import Create from './Create';
import Edit from './Edit';

export default {
  name: 'state_location_type_rate_settings',
  inputShow: gql`
    query stateLocationTypeRateSettings($input: StateLocationTypeRateSettingQueryInput) {
      stateLocationTypeRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'State Location Type Rate Settings',
    order: 7,
  },
};
